/**
 * User: daletan
 * Date: 12/22/14
 * Time: 5:17 PM
 * Copyright 1stdibs.com, Inc. 2014. All Rights Reserved.
 */
'use strict';
var $ = require('dibs-jquery-shim');
var _ = require('underscore');
var Backbone = require('dibs-backbone');
var _localStorage = require('dibs-browser-storage').localStorage;
var DC = require('bunsen/helpers/dibsConstants');
var SV = require('server-vars');
var uriHelper = require('bunsen/helpers/uri.es');
var RecentHistoryWrapperView = require('./RecentHistoryWrapperView');
var KEY = 'recent_history_list';
var COUNT_KEY = 'recent_history_count';
var queryParamWhiteList = ['cur_tab'];
var MAX_ITEMS = 6;
var MAX_DAYS = 30;
var daysBetween;
var getItemId;
var isCurrentItem;
var getUrlParams;
var getPdpUrl;
var isPdp;
var isSuspended;
var isAllowed;
var getList;
var addItem;
var renderList;

require('jquery-operator');

/**
 *
 * calculate days between two given timestamps
 * @param  {number} timestamp1  timestamp in ms, ie 1392139288947
 * @param  {number} timestamp2
 * @return {Number} rounded difference in days
 */
daysBetween = function(timestamp1, timestamp2) {
    var msDiff = Math.abs(timestamp1 - timestamp2);
    var oneDayInMs = 86400000; // 24h/d * 60m/h * 60s/m * 1000ms/s
    return Math.round(msDiff / oneDayInMs);
};
getItemId = function(item) {
    // switching data to use camelCase properties
    // but there are still under_scored ones
    return item.itemId || item.item_id;
};
isCurrentItem = function(item, currentItem) {
    var itemId = getItemId(item);
    var curItemId;
    if (currentItem) {
        curItemId = currentItem.itemId || currentItem.item_id;
    }
    return itemId === curItemId;
};

/**
 * checks for any whitelisted query params to add back to the item URI
 * @returns {string}
 */
getUrlParams = function() {
    var queryKey = uriHelper.URL.queryKey;
    var result = [];

    _.each(queryParamWhiteList, function(key) {
        if (queryKey[key]) {
            result.push(key + '=' + queryKey[key]);
        }
    });

    if (result.length) {
        return '?' + result.join('&');
    }
    return '';
};

/**
 * TRANACT-2207 return a url for PDP pages with whitelisted param, if applicable
 *
 * @returns {string}
 */
getPdpUrl = function() {
    var params = getUrlParams();
    return uriHelper.URL.path + params;
};

/**
 * is the user on a pdp?
 * @returns {boolean}
 */
isPdp = function() {
    return SV.data && SV.data.pdp;
};
/**
 *
 * @param {object} itemData Item data from the server, NOT the inventory item model
 * @returns {boolean}
 */
isSuspended = function(itemData) {
    // TRANACT-2007 filtered out deleted/unpublished/dealer suspended items from the list
    // these `itemData[prop]` values come from php
    return itemData && (itemData.isDeleted || itemData.isUnpublished || itemData.isDealerSuspended);
};
/**
 * Is the item allowed to be put into the recent history stack?
 * @param {object} item The
 * @param {object} [currentItem]
 * @returns {boolean}
 */
isAllowed = function(item, currentItem) {
    // original logic: (daysBetween(itemTimestamp, _now) >= 30 || (currentItem && currentItem.itemId === itemId))
    var _now = currentItem ? currentItem.timestamp : new Date().getTime();
    return daysBetween(item.timestamp, _now) >= MAX_DAYS || isCurrentItem(item, currentItem);
};
/**
 * return the list without the item(s) that is: >30 days old || already in the list || falsey value
 * @param  {Array} historyList    the history list, optional
 * @param  {Number} currentItem item id, will NOT perform uniqueness check if not given
 * @return {Array}
 */
getList = function(historyList, currentItem, maxItems) {
    var recentHistoryList = historyList || _localStorage.getItem(KEY);
    var itemCount;
    maxItems = maxItems || MAX_ITEMS;

    _.each(recentHistoryList, function(item, index) {
        if (isAllowed(item, currentItem)) {
            recentHistoryList[index] = null;
        }
    });

    // remove falsey element(s) in the list
    // how can anything be falsy in this case?
    recentHistoryList = _.compact(recentHistoryList);

    itemCount = recentHistoryList.length;
    while (itemCount > maxItems) {
        recentHistoryList = recentHistoryList.slice(1, itemCount);
        itemCount--;
    }

    _localStorage.setItem(COUNT_KEY, recentHistoryList.length);
    return recentHistoryList;
};
/**
 * Add an item to the user's localStorage object
 * @param {object} itemData
 * @param {string} itemData.smallImage The item image
 * @param {string} [itemData.pk] The item pk
 * @returns {*}
 */
addItem = function(itemData) {
    var _now;
    var storedList;
    var recentHistoryList;
    var currentItem;

    if (isSuspended(itemData) || !itemData.smallImage) {
        // TRANACT-2007 add to the list only if it is not suspended
        return false;
    }

    _now = new Date();
    storedList = _localStorage.getItem(KEY);
    recentHistoryList = storedList || [];
    currentItem = {
        itemTitle: itemData.titleCondensed || itemData.title || document.title,
        itemId: itemData.pk || '',
        itemImageUrl: itemData.smallImage,
        itemPdpUrl: getPdpUrl(),
        dealerPk: itemData.dealerPk,
        timestamp: _now.getTime(),
        lastVisited: _now,
    };

    recentHistoryList = getList(recentHistoryList, currentItem);
    recentHistoryList.push(currentItem);

    return _localStorage.setItem(KEY, JSON.stringify(recentHistoryList));
};
renderList = function(targetEl) {
    // on Seach & Browse
    var cleanedList = getList();
    var collectionView;

    if (!isPdp() && cleanedList.length) {
        // only render this view on a non-pdp
        collectionView = new RecentHistoryWrapperView({
            listCollection: new Backbone.Collection(cleanedList.reverse()),
            targetEl: targetEl || null,
        });
        collectionView.render();
    }
};

module.exports = {
    // for testing purposes
    MAX_DAYS: MAX_DAYS,
    MAX_ITEMS: MAX_ITEMS,
    STORAGE_KEY: KEY,
    COUNT_KEY: COUNT_KEY,
    addItem: addItem,
    daysBetween: daysBetween,
    getList: getList,
    renderList: renderList,
    clearList: function() {
        _localStorage.deleteItem(KEY);
        _localStorage.deleteItem(COUNT_KEY);
    },
};

$(function() {
    if (isPdp()) {
        // on PDP
        addItem(SV.data);
        return;
    }
    $.publish('recentHistory:render');
});

$.subscribe('recentHistory:render ' + DC.pageEventPrefix + ':updated', function() {
    renderList();
});



//////////////////
// WEBPACK FOOTER
// ./assets/js/global/modules/recentHistory/recentHistory.js
// module id = 602
// module chunks = 4 5 6 7 8